<span [ngClass]="{'textRed': isErrorExist, 'textUnderlined':isErrorHigh && isPageEfileSearchResult }">{{params.value}}
  <span *ngIf="isErrorHigh && isPageEfileSearchResult" class="tooltip-hover " [ngClass]="tolltipHoverClass" class="textUnderlined">
    <i class="fas fa-exclamation-circle" pTooltip="{{'chargeback.' + moduleString +'.highErrorsFoundTooltip' | translate}}" [escape]="false" tooltipPosition="top"></i>
  </span>
</span>